<template>
  <Aggregate
    title="Inverter"
    v-model="computedValue"
    :ItemConstructor="CaseModel.Inverter"
    :headers="CaseModel.Inverter.HEADERS"
    :cardProps="{ flat: true, class: [] }"
    toolbar-dense
    dense
  >
    <template #item.power_capacity="{ item }">
      <p class="mb-2">{{ item.power_capacity }} MVA</p>
    </template>
    <template #default="{ item }">
      <v-card class="pa-2 ma-2" flat>
        <v-card-text>
          <v-card flat class="mb-6">
            <p class="text-subtitle-1 font-weight-bold">Capacity</p>
            <v-row dense>
              <v-col cols="12" sm="6">
                <InputTextField
                  v-model="item.power_capacity"
                  :label="schema.power_capacity.title"
                  :hint="schema.power_capacity.tooltip"
                  :suffix="schema.power_capacity.unit"
                  :label-size="8"
                  type="number"
                  @change="$emit('change')"
                ></InputTextField>
              </v-col>
              <v-col cols="12" sm="6">
                <ChartPlotly :data="[]" :layout="capabilityChartLayout(item)"></ChartPlotly>
              </v-col>
            </v-row>
            <v-divider class="mt-4"></v-divider>
          </v-card>
        </v-card-text>
      </v-card>
    </template>
  </Aggregate>
</template>

<script>
import { CaseModel, schemas } from "data-dictionary";

export default {
  name: "SystemInverter",
  components: {
    Aggregate: () => import("@/components/Aggregate.vue"),
    ChartPlotly: () => import("@/components/charts/Plotly.vue"),
    InputTextField: () => import("@/components/inputs/InputTextField.vue"),
  },
  mixins: [],
  props: {
    value: { type: Array, required: false, default: () => [] },
    yearStart: { type: Number, required: true },
    numYears: { type: Number, required: true },
  },
  data() {
    return {
      CaseModel,
      schema: {
        ...schemas.find((v) => v.$id === "inverter.schema.json").properties,
      },
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change");
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    capabilityChartLayout(item) {
      const powerCapacity = item.power_capacity;
      return {
        hovermode: "closest",
        showlegend: false,
        font: { size: 10 },
        title: {
          text: "Reactive Capability Curve",
        },
        height: 240,
        margin: { t: 40, b: 60, l: 80, r: 60 },
        xaxis: {
          range: [-powerCapacity * 1.1, powerCapacity * 1.1],
          fixedrange: true,
          tickvals: [-1, -0.5, 0.5, 1].map((v) => v * powerCapacity),
          title: {
            text: "Reactive Power",
            font: { size: 10 },
          },
        },
        yaxis: {
          range: [-powerCapacity * 1.1, powerCapacity * 1.1],
          fixedrange: true,
          rangemode: "tozero",
          scaleanchor: "x",
          constrain: "domain",
          title: {
            text: "Active Power",
            font: { size: 10 },
          },
        },
        annotations: [],
        shapes: [
          /* ...[0.5, 1]
            .map((v) => v * powerCapacity)
            .map((v) => ({
              type: "circle",
              xref: "x",
              yref: "y",
              x0: v,
              y0: v,
              x1: -v,
              y1: -v,
              line: {
                color: "#dadada",
                width: 1,
              },
            })), */
          {
            type: "circle",
            xref: "x",
            yref: "y",
            x0: powerCapacity,
            y0: powerCapacity,
            x1: -powerCapacity,
            y1: -powerCapacity,
            line: {
              width: 1,
              color: "rgb(255, 127, 14)",
            },
          },
        ],
      };
    },
  },
};
</script>

<style></style>
